export const TRADES_MAN_LEVEL = [1, 2, 3, 4];
